export const ETHER_Address = '0x0000000000000000000000000000000000000000'
export const DECIMALS = (10**18)
export const GREEN = 'success'
export const RED = 'danger'

export const ether = (wei) => {
    if(wei) {
        return(wei / DECIMALS)
    }
}
export const tokens = ether //Tokens and Ether have to use 18 decimals